import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Tooltip } from 'antd';
import { MdInfoOutline } from "react-icons/md";
import DOMPurify from 'dompurify';

class OrderDetailsItem extends Component {

  static defaultProps = {
    itemValue: '',
    itemName: '',
    tooltipText: '',
    style: {}
  };

  state = {
    showToolTip: false
  }

  constructor(props) {
    super(props)
    this.myRef = React.createRef();
  }

  render() {
    const { style } = this.props;
    return (
      <div className="order-details-item" style={style}>
        <span className="order-details-item-text">
          <FormattedMessage id={this.props.itemName} />
          {
            this.props.tooltipText ? (
              <Tooltip
                placement="right"
                title={<div dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(this.props.tooltipText, {
                    ADD_ATTR: ['target', 'rel'],
                    ALLOWED_ATTR: ['href', 'target', 'rel']
                  })
                }} />}
              >
                <MdInfoOutline className="tooltip-icon" />
              </Tooltip>
            ) : null
          }
        </span>
        <span className="order-details-item-text">{this.props.itemValue} </span>
      </div>
    );
  }

}

export default OrderDetailsItem;
